import { TreatDrug } from '@uplift/types';
import { restClient } from '../../client';

export type GetTreatDrugsResponse = {
  data: TreatDrug[];
};

export const getTreatDrugs = (drugName: string) =>
  restClient.request<GetTreatDrugsResponse>(`/vendor/treat/drugs?drug_name=${drugName}`);
